import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Teams from './Team';
import TeamAddOrEdit from './TeamAdd/TeamAddOrEdit';
import TeamProfile from './TeamProfile/TeamProfile';
import ProfileForm from './TeamProfile/ProfileForm/ProfileForm';
import JCodeSettings from './TeamProfile/JCodeSettings/JCodeSettings';

export const TeamsRoutes = (
  <Route path="team" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health', 'Manufacturer Users']}>
          <Teams />
        </PrivateRoute>
            )}
    />

    <Route
      path="add"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health', 'Manufacturer Users']}>
          <TeamAddOrEdit />
        </PrivateRoute>
          )}
    />

    <Route
      path=":userId/edit"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Health', 'Manufacturer Users']}>
          <TeamAddOrEdit />
        </PrivateRoute>
          )}
    />

    <Route path=":userId/profile" element={<Outlet />}>
      <Route
        index
        element={(
          <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Health', 'Patient', 'Manufacturer Users']}>
            <TeamProfile />
          </PrivateRoute>
        )}
      />

      <Route
        path="edit"
        element={(
          <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Health', 'Patient', 'Manufacturer Users']}>
            <ProfileForm />
          </PrivateRoute>
        )}
      />

      <Route
        path="j-codes"
        element={(
          <PrivateRoute roles={['Admin', 'Pharmacy', 'Rep', 'Physician', 'Health', 'Patient', 'Manufacturer Users']}>
            <JCodeSettings />
          </PrivateRoute>
        )}
      />
    </Route>

  </Route>
);
